<template>   
    <b-alert v-model="showAlert" :variant=type dismissible>
      <span>{{messageTranslated}}</span>
    </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
export default {
    name: 'BaseAlert',
    components : {
        'b-alert': BAlert
    },
    data() {
      return {
        showAlert: false
      }
    },    
    computed: {      
        messageTranslated : function() {
            return this.$t(this.$store.state.alert.message);            
        },
        type : function() {                        
            return this.$store.state.alert.type;
        }     
    },
    watch: {
        '$store.state.alert.show': function(val) {
            this.showAlert = val;
        },
        'showAlert': function(val) {
            this.$store.commit("CHANGE_ALERT_SHOW",val);
        }
    }
}
</script>
<style>
    .close {
        color: black !important;
    }
    .alert-dismissible .close {
        top: -4px !important;
    }
</style>